import * as Yup from "yup";

import { isCPF } from "Services/schema/validations";
import { isValidPhoneMask } from "Utils/Phone";

export const linkRemotoSchema = Yup.object().shape({
  name: Yup.string().required("Nome é obrigatório"),
  email: Yup.string()
    .email("E-mail inválido")
    .required("E-mail é obrigatório"),
  document_type: Yup.string().required("Informe o tipo de documento"),
  document: Yup.string().when("document_type", {
    is: (documentType: string) => documentType === "cpf",
    then: Yup.string()
      .required("Documento é obrigatório")
      .test("validateCpf", "CPF inválido", isCPF),
    otherwise: Yup.string().required("Documento é obrigatório"),
  }),
  phone: Yup.string()
    .required("Telefone é obrigatório")
    .test("phone", "Telefone inválido", (value) => isValidPhoneMask(value)),
  amount: Yup.number()
    .typeError("Valor é obrigatório")
    .required("Valor é obrigatório")
    .moreThan(0, "Valor deve ser maior que zero"),
});
